import cx from 'classnames';

import PlusIcon from 'src/assets/icons/Plus';
import { CustomButton } from 'src/components/CustomButton';
import { STONLY_ID } from 'src/lib/stonly';

import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const CreateContentItem = ({ className }) => {
  const styles = useStyles();

  const { handleNewProjectClick } = useHandlers();

  return (
    <div className={cx(styles.root, className)}>
      <CustomButton
        className={styles.button}
        onClick={handleNewProjectClick}
        startIcon={<PlusIcon />}
        data-stonly-id={STONLY_ID.createDocumentButton}
        data-testid="createContentButton"
      >
        Create content
      </CustomButton>
    </div>
  );
};
